import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, BadgeEuro, Zap, MapPin } from "lucide-react";

const items = [
  {
    icon: ShieldCheck,
    title: "Eigen gecertificeerde monteurs",
    desc: "Geen onderaannemers. Premium installatie met 5 jaar service vanuit Helios Bright.",
  },
  {
    icon: BadgeEuro,
    title: "Eerlijke vaste prijs",
    desc: "Transparante all-in offerte. Geen verrassingen achteraf, inclusief installatie en configuratie.",
  },
  {
    icon: Zap,
    title: "Premium A-merken op voorraad",
    desc: "Tesla, Huawei, BYD en Zaptec. Korte levertijd, geen wachttijden van maanden.",
  },
  {
    icon: MapPin,
    title: "Lokaal in Noord-Nederland",
    desc: "Helios Bright zit in Groningen. Korte lijnen, snelle service en advies op locatie.",
  },
];

const USPStrip = () => {
  return (
    <section className="py-12 lg:py-14 bg-white border-b border-slate-100" data-testid="usp-strip">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-2xl mx-auto mb-10"
        >
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand mb-3">Waarom Helios Bright</p>
          <h2 className="font-heading text-3xl md:text-4xl font-black tracking-tighter text-navy-900 text-balance">
            De duidelijke keuze voor jouw thuisbatterij.
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((u, i) => (
            <motion.div
              key={u.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.4, delay: i * 0.07 }}
              className="rounded-2xl border border-slate-100 bg-slate-50/60 p-5 hover:bg-white hover:border-brand/20 hover:shadow-[0_20px_50px_rgba(255,47,125,0.08)] hover:-translate-y-1 transition-all duration-300"
              data-testid={`usp-card-${i}`}
            >
              <span className="w-11 h-11 rounded-xl gradient-pink text-white flex items-center justify-center mb-4">
                <u.icon size={20} />
              </span>
              <h3 className="font-heading font-bold text-lg text-navy-900 leading-snug">{u.title}</h3>
              <p className="text-sm text-slate-600 mt-1.5 leading-relaxed">{u.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default USPStrip;
